import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ICashierRevenue } from '../interfaces/cashier/revenue';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CashierService {

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get(`${environment.url}/api/cashier/revenue`) as Observable<
      ICashierRevenue[]
    >;
  }


  getBalanceByDay(date: string) {
    return this.http.get(`${environment.url}/balance`, {params: {date}})
  }
}
